/* src/app/components/base-accordion/base-accordion.component.scss */
/*# sourceMappingURL=base-accordion.component.css.map */
